<svg id="cb-loader-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.18 77.18">
    <path
      d="M63.18,38.59c0,6.3-2.4,12.6-7.2,17.4-9.59,9.59-25.21,9.59-34.8,0s-9.59-25.21,0-34.8c4.8-4.8,11.1-7.2,17.4-7.2V0C28.7,0,18.82,3.76,11.29,11.29c-15.05,15.05-15.05,39.55,0,54.6,15.05,15.05,39.55,15.05,54.6,0,7.53-7.53,11.29-17.41,11.29-27.3h-13.99Z" />
</svg>